import type { HomeBannersDto } from './models';
import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HomeBannersSettingsService {
  apiName = 'Default';
  

  getHomeBanners = () =>
    this.restService.request<any, HomeBannersDto>({
      method: 'GET',
      url: '/api/app/home-banners-settings/home-banners',
    },
    { apiName: this.apiName });
  

  setHomeBanners = (input: HomeBannersDto) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/home-banners-settings/set-home-banners',
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
